export enum LoiFormAnswerType {
    String = 0,
    Number = 1,
    Date = 2,
    PurchaseAgreementType = 3,
    LeaseRateUponExtension = 4,
    LeaseType = 5,
}

export interface LoiFormAnswerTypeOption {
    value: string;
    label: string;
}

export const LoiFormAnswerTypeList: Array<{
    id: LoiFormAnswerType;
    name: string;
    options?: LoiFormAnswerTypeOption[];
    isImplemented?: boolean;
}> = [
    { id: LoiFormAnswerType.String, name: 'String' },
    { id: LoiFormAnswerType.Number, name: 'Number' },
    { id: LoiFormAnswerType.Date, name: 'Date', isImplemented: false },
    {
        id: LoiFormAnswerType.PurchaseAgreementType,
        name: 'Purchase Agreement Type',
        options: [
            { value: 'Assets', label: 'Assets' },
            { value: 'Equity', label: 'Equity' },
        ],
    },
    {
        id: LoiFormAnswerType.LeaseRateUponExtension,
        name: 'Lease Rate Upon Extension',
        options: [
            { value: 'FMV Reset', label: 'FMV Reset' },
            { value: 'Annual Escalation %', label: 'Annual Escalation %' },
        ],
    },
    {
        id: LoiFormAnswerType.LeaseType,
        name: 'Lease Type',
        options: [
            { value: 'Triple Net Lease (NNN)', label: 'Triple Net Lease (NNN)' },
            { value: 'Gross Lease / Full-Service Lease', label: 'Gross Lease / Full-Service Lease' },
            { value: 'Modified Gross Lease', label: 'Modified Gross Lease' },
            { value: 'Double Net Lease (NN)', label: 'Double Net Lease (NN)' },
            { value: 'Single Net Lease (N)', label: 'Single Net Lease (N)' },
            { value: 'Percentage Lease', label: 'Percentage Lease' },
            { value: 'Absolute Lease', label: 'Absolute Lease' },
        ],
    },
];

export function getOptionsForAnswerType(
    answerType: LoiFormAnswerType
): LoiFormAnswerTypeOption[] {
    const entry = LoiFormAnswerTypeList.find((e) => e.id === answerType);
    return entry?.options ?? [];
}

export const REAL_PROPERTY_OPTIONS = [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }] as const;